import { ThemeSettings } from '../types/theme'

let theme: ThemeSettings | undefined

export const hasTheme = () => theme !== undefined

export const getTheme = () => theme

export const applyTheme = (themeSettings: ThemeSettings) => {
    const root = document.documentElement

    Object.entries(themeSettings.css).forEach(([key, value]) => {
        if (value) {
            root.style.setProperty(`--${key}`, value)
        }
    })

    theme = themeSettings
}
